<template>
  <div class="image-container">
    <img ref="main" class="fill-image" :src="getImageUrl(src)" :alt="alt" />
  </div>
</template>

<script>
import getImageSrc from '@/util/getImageSrc'

/**
 * This is used in Instructions
 */
export default {
  name: 'FillImage',
  methods: {
    getImageUrl(url) {
      const fullUrl = `${this.$store.state.exam.base_media_url}/${url}`
      return getImageSrc(fullUrl, this.imageCache)
    }
  },
  props: {
    src: {
      type: String,
      default: '',
      required: true
    },
    alt: {
      type: String,
      default: '',
      required: true
    },
    imageCache: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style scoped>
.image-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: 100%;
  align-items: center;
}
img.fill-image {
  width: auto;
  height: 100%;
  max-width: min(100%, 25rem);
  flex-basis: 100%;
  object-fit: contain;
}
</style>
